import { Accent, IColourScheme, TagLabel } from '@tag/tag-components-react-v3';
import React from 'react';
import styled from 'styled-components';

import { CommonElementProps } from '../Common/CommonElementProps';
import { outline } from '../Common/CommonStyles';
import Skeleton from '../Skeleton/Skeleton';

export interface LabelProps extends CommonElementProps {
  readonly accent?: Accent;
  readonly textStyle?: React.CSSProperties;
  readonly colourScheme?: IColourScheme;
  readonly className?: string;
}

const StyledLabel = styled(TagLabel)`
  label {
    ${outline}
  }
`;

const Label = (props: LabelProps): JSX.Element => (
  <>
    {props.isLoading ? (
      <Skeleton height="10px" maxWidth="200px" />
    ) : (
      <StyledLabel {...props} data-testid={props.dataTestId} className={props.className} />
    )}
  </>
);

export default Label;
